export default (theme) => ({
    root: {},
    clockIcon: {
        marginLeft: 6,
    },
    isFullWidth: {
        width: '100%',
    },
});
